import React, { useEffect, useState } from 'react';
import {
  Button,
  Typography,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import { useHistory, useLocation } from 'react-router-dom';
import SimpleSelect from '../../util/SimpleSelect';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, WideBox, StyledForm } from '../../styles/styles';
import Spinner from '../../util/Spinner';
import { AccountSchema } from '../../../validation';
import ACDropdown from '../../util/ACDropdown';

const NewAccount = () => {
  const history = useHistory();
  const { authStore, dataStore, orgStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [accountTypes, setAccountTypes] = useState([]);

  const { settings } = orgStore;

  const { ExtSysId } = settings;
  const location = useLocation();

  const parseQuery = () => {
    const q = location.search
      .slice(1)
      .split('%20')
      .join(' ');
    let type = '';

    switch (q) {
      case 'Accounts Receivable':
        type = 1;
        break;
      case 'Accounts Payable':
        type = 2;
        break;
      case 'Asset':
        type = 3;
        break;
      case 'Liability':
        type = 4;
        break;
      case 'Income':
        type = 6;
        break;
      case 'Expense':
        type = 7;
        break;
      default:
        break;
    }

    return type;
  };

  const fetchAccountTypes = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/account-types`,
      );
      setAccountTypes(data);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    const initialize = async () => {
      await fetchAccountTypes();
      setLoading(false);
    };
    initialize();
  }, []);

  const initialValues = {
    accountCode: '',
    accountName: '',
    type: location.state ? parseQuery() : '',
    statusId: 1,
    bankAccountType: '',
  };

  if (isLoading) return <Spinner />;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={AccountSchema}
      onSubmit={async (values, actions) => {
        try {
          await authStore.request.post(
            `${process.env.REACT_APP_API}/api/account`,
            {
              ...values,
            },
          );
          await dataStore.retrieveAccounts();
          history.push('/accounts');
        } catch (e) {
          console.error(e);
          actions.setSubmitting(false);
        }
      }}
      render={({
        handleBlur,
        handleChange,
        errors,
        handleSubmit,
        values,
        touched,
        dirty,
        isSubmitting,
        setFieldValue,
      }) => {
        const showError = val => errors[val] && touched[val];
        return (
          <FlexDiv>
            <WideBox style={{ justifyContent: 'center' }}>
              <Typography variant="h2" gutterBottom>
                New Account
              </Typography>
              <StyledForm onSubmit={handleSubmit}>
                <TextField
                  name="accountName"
                  label="Account Name"
                  value={values.accountName}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                  error={showError('accountName')}
                />
                <TextField
                  name="accountCode"
                  label="Account Code"
                  value={values.accountCode}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                  error={showError('accountCode')}
                />
                {/* fix uncontrolled value state warning */}
                <ACDropdown
                  textFieldProps={{ margin: 'normal' }}
                  label="Account Type"
                  style={{ width: '100%' }}
                  onChange={(e, newVal) =>
                    setFieldValue('type', newVal.AccountTypeId)
                  }
                  value={accountTypes.find(
                    x => x.AccountTypeId === values.type,
                  )}
                  options={accountTypes}
                  getOptionLabel={option => option.Name}
                  getOptionSelected={(option, val) => {
                    if (val === '') {
                      return true;
                    }
                    if (option.AccountTypeId === val.AccountTypeId) {
                      return true;
                    }
                  }}
                />
                <TextField
                  name="bankAccountType"
                  label="Bank Account Type"
                  value={values.bankAccountType}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                  error={showError('bankAccountType')}
                  disabled={ExtSysId !== 0}
                />
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!values.statusId}
                        onChange={(x, bool) =>
                          setFieldValue('statusId', bool ? 1 : 0)
                        }
                        value={values.statusId}
                      />
                    }
                    label="Visible"
                  />
                </div>
                <div
                  css={css`
                    display: flex;
                    margin-top: 1.2rem;
                    justify-content: flex-end;
                    & > button {
                      margin: 5px;
                    }
                  `}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="large"
                    disabled={isSubmitting || !dirty}
                    style={{
                      margin: '5px',
                    }}
                  >
                    Submit
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="large"
                    onClick={() => history.goBack()}
                    style={{
                      margin: '5px',
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </StyledForm>
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default NewAccount;
